/**
 * What a viewing session is doing on the customer page — the verb only. What it is
 * being done to lives in CustomerViewerActivityTarget, so the two axes stay separate
 * rather than multiplying into COMPOSING_NOTE, COMPOSING_TASK, and so on.
 */
const CustomerViewerActivity = {
  VIEWING: 'VIEWING',
  COMPOSING: 'COMPOSING',
};

/** Whether an activity acts on something, and so may carry a target. */
export function takesTarget(activity) {
  return activity === CustomerViewerActivity.COMPOSING;
}

export default CustomerViewerActivity;
